$(function() {

    $.supporter = {};

    $.supporter.delayFadeOut = ($("#supporter-container").next('section').hasClass('profile-section')) ? false : true;

    $.supporter.lastProfile = false;

    // durations

    $.supporter.duration = '75%';

    $.supporter.calculatePinDuration = function() {
        var contentHeight = $('#supporter-container .content-container').outerHeight();
        if ($.supporter.lastProfile) {
            $.supporter.pinDuration = 0;
        } else {
            $.supporter.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.supporter.pinDuration;
	};

    $.supporter.zoomDuration = '100%';

    $.supporter.endDuration = ($.supporter.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.supporter.tl = {};

    // in

	$.supporter.tl.in = new TimelineMax();

    $.supporter.tl.in.addLabel("start");

    $.supporter.tl.in.set("#supporter-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.supporter.tl.in.from("#supporter-svg .line-1", 1, { x:"2560" }, "start");
        $.supporter.tl.in.from("#supporter-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.supporter.tl.in.from("#supporter-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.supporter.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#supporter-in', triggerHook: 'onEnter', duration: $.supporter.duration })
        	.setTween($.supporter.tl.in)
        	// .addIndicators({name: 'supporter in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#supporter-pin', triggerHook: 'onLeave', duration: $.supporter.calculatePinDuration })
        .setPin('#supporter-container .svg-background')
        // .addIndicators({name: 'supporter pin'})
        .addTo($.controller);

    // zoom

    $.supporter.zoom = {};

    $.supporter.tl.zoom = new TimelineMax();

    $.supporter.tl.zoom.addLabel("start");
    $.supporter.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.supporter.tl.zoom.to("#supporter-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.supporter.zoom.scale = 10;
        $.supporter.zoom.offset = $.supporter.zoom.scale * 100 / 2;
        $.supporter.zoom.xy = "-"+ $.supporter.zoom.offset +"%";

        $.supporter.tl.zoom.to("#supporter-svg .svg-text", 2, { x:$.supporter.zoom.xy, y:$.supporter.zoom.xy, scaleX:$.supporter.zoom.scale, scaleY:$.supporter.zoom.scale, force3D:true }, "start");

    }

    $.supporter.tl.zoom.to("#supporter-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.supporter.tl.zoom.to("#supporter-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.supporter.tl.zoom.fromTo("#supporter-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.supporter.tl.zoom.set("#supporter-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.supporter.tl.zoom.set("#supporter-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.supporter.tl.zoom.fromTo("#supporter-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.supporter.tl.zoom.fromTo("#supporter-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.supporter.tl.zoom.fromTo("#supporter-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.supporter.tl.zoom.fromTo("#supporter-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#supporter-zoom', triggerHook: 'onCenter', duration: $.supporter.zoomDuration })
        .on('start', function () {
            $.supporter.tl.in.seek($.supporter.tl.in.duration(), false);
        })
        .setTween($.supporter.tl.zoom)
        // .addIndicators({name: 'supporter zoom'})
        .addTo($.controller);

    $.supporter.tl.out = new TimelineMax();

    $.supporter.tl.out.addLabel("start");

    $.supporter.tl.out.to("#supporter-container .content-container", 1, { opacity:0 }, "start");

    if ($.supporter.delayFadeOut) {
        $.supporter.tl.out.to("#supporter-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.supporter.tl.out.to("#supporter-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#supporter-end', triggerHook: 'onCenter', duration: $.supporter.endDuration })
        .setTween($.supporter.tl.out)
        // .addIndicators({name: 'supporter out'})
        .addTo($.controller);

});
